type Params = { name: string; shortTitle?: string | null }

export const getPlannerName = ({ name, shortTitle }: Params) => {
  if (!shortTitle) return name
  return shortTitle
}
